import { Col } from 'antd'
import React, { useContext } from 'react'
import { FormItem } from '../../../../../../components/UIComponents/FormStyles'
import { RuleContext } from '../../RulesCreationTable'
import { StyledRuleRow, StyledTextInput } from '../../style'
import { StyledBoldTextOne, TextContainer, TextLine } from '../CTCDrawers/style'

const MaximumApplicationDrawer = () => {
  const {
    ruleForm,
    state: { maxRolesAllowed },
    setState,
  } = useContext(RuleContext)
  const handleChange = e => {
    const currentRoles = ruleForm.getFieldValue('maxRolesAllowed')

    ruleForm.setFieldsValue({
      maxRolesAllowed: {
        ...currentRoles,
        roleCount: e.target.value,
        // isEnabled: e.target.value ? true : false,
      },
    })
    setState(prevState => ({
      ...prevState,
      maxRolesAllowed: {
        ...prevState.maxRolesAllowed,
        roleCount: e.target.value,
        // isEnabled: e.target.value ? true : false,
      },
    }))
  }

  return (
    <>
      <TextContainer>
        <TextLine>
          In this rule, enter the no. of roles a student can apply for.
        </TextLine>
      </TextContainer>

      <StyledRuleRow align={'middle'} pBottom={20} pTop={30}>
        <Col md={8}>
          <StyledBoldTextOne>
            No. of roles allowed
            <StyledBoldTextOne>per student</StyledBoldTextOne>
          </StyledBoldTextOne>
        </Col>
        <Col>
          <FormItem
            name={['maxRolesAllowed', 'roleCount']}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value == 0) {
                    return Promise.reject(
                      new Error('Please enter the no. of roles')
                    )
                  }
                  
                  if (value < 0) {
                    return Promise.reject(new Error('Negative values are not allowed'))
                  }
                  
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <StyledTextInput
              type="number"
              placeholder="0"
              width="200px"
              height={'40px'}
              onChange={e => handleChange(e)}
              value={maxRolesAllowed?.roleCount || 0}
            />
          </FormItem>
        </Col>
      </StyledRuleRow>

      <TextContainer>
        <TextLine>
          If students exhaust the number of roles they can apply, they can
          obtain approval to apply for more.
        </TextLine>
      </TextContainer>
    </>
  )
}
export default MaximumApplicationDrawer
